import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Card, CardHeader, CardTitle } from "@shared/ui/card";
import { Activity, Package, TrendingUp } from "lucide-react";
import React from "react";

interface KeyMetricsRowProps {
  data: any;
}

export const KeyMetricsRow: React.FC<KeyMetricsRowProps> = ({ data }) => {
  const getPerformanceStatus = (score: number) => {
    if (score >= 80) return "Excellent";
    if (score >= 60) return "Good";
    return "Needs Attention";
  };

  const getAlertStatus = (alerts: number) => {
    if (alerts === 0) return "All Clear";
    if (alerts <= 2) return "Monitor";
    return "Urgent";
  };

  const statsData = [
    {
      title: "Current Capacity",
      count: `${data?.currentThroughput ?? "NA"}/${
        data?.designCapacity ?? "NA"
      }`,
      icon: <Activity className="h-8 w-8 text-blue-500" />,
      tooltip:
        "The system's current operational throughput compared to its maximum design capacity.",
    },
    {
      title: "Operational Performance",
      count: data?.operationalPerformance ?? "NA",
      icon: <TrendingUp className="h-8 w-8 text-purple-500" />,
      tooltip:
        "A real-time performance index based on uptime, efficiency, and other key operational parameters.",
    },
    // {
    //   title: "Critical Alerts",
    //   count: data?.criticalAlerts ?? "NA",
    //   trendSummary: getAlertStatus(data?.criticalAlerts),
    //   icon: <AlertTriangle className="h-8 w-8 text-green-500" />,
    //   tooltip:
    //     "The number of active, high-priority alerts that require immediate attention for this system. Click to view details.",
    // },
    {
      title: "Total Assets",
      count: data?.assetCount ?? "NA",
      icon: <Package className="h-8 w-8 text-orange-500" />,
      tooltip:
        "The total number of individual assets (e.g., pumps, valves, filters) that make up this system. Click to view the full list.",
    },
  ];

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <div className="text-xs">📊</div>
          <CardTitle className="text-lg font-semibold">Key Metrics</CardTitle>
        </div>
      </CardHeader>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {statsData.map((stat, index) => (
          <QuickStatsCard
            key={index}
            title={stat.title}
            count={stat.count}
            trendSummary={stat.trendSummary}
            icon={stat.icon}
            tooltip={stat.tooltip}
          />
        ))}
      </div>
    </Card>
  );
};
